/**
 * Fitness Score (F4.3): current score + history (`/v2/stats/fitness-score`;
 * optional `clientId` with read consent — 403 mapped by ClientStatsGuard).
 */
import type {
  FetchFitnessScoreArgs,
  ApiFitnessScore,
} from './types/statsInsights.types';

import { get } from './axios';

export const fetchFitnessScore = async (args: FetchFitnessScoreArgs = {}) => {
  const response = await get<ApiFitnessScore>('/v2/stats/fitness-score', {
    query: { clientId: args.clientId, from: args.from, to: args.to },
  });
  return response ?? null;
};
